import { render, staticRenderFns } from "./BaseForm.vue?vue&type=template&id=545ea00a"
import script from "./BaseForm.vue?vue&type=script&lang=ts"
export * from "./BaseForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports